import React from 'react'
import { CornerDegreeIcon } from 'src/editor/shared/icons/corner-degree-icon'
import { NumberInput } from 'src/editor/shared/ui-lib/input/number-input'

export interface ColorPickerGradientAngleProps {
  angle: number
  setAngle: (angle: number) => void
}

export const ColorPickerGradientAngle = ({
  angle,
  setAngle,
}: ColorPickerGradientAngleProps) => {
  return (
    <div className="relative w-full pb-4">
      <NumberInput
        value={angle}
        onChange={setAngle}
        min={0}
        max={359}
        startElement={<CornerDegreeIcon />}
      />
      <hr className="-left-4 -right-4 absolute bottom-0 border-divider00" />
    </div>
  )
}
